import { useEffect } from 'react'
import { useFormikContext } from 'formik'
import { useParams } from 'react-router-dom'

import { Input } from 'components/form/input'
import SizeSectionList from 'components/form/size-section-list'
import { useSelectedSizeGroup } from 'store/server/useOrderLookups'
import { matchSnapshot, zaraSizeName } from 'lib/matchCatalogSizes'
export default function PriceSizes({ idx,tab }) {
  const { orderNo } = useParams()
  const { values, setFieldValue } = useFormikContext()
  const { data: findSizeData } = useSelectedSizeGroup()

  useEffect(() => {
    if (!findSizeData?.sizes) return
    const snapshots = values.priceLabel[idx]?.sizes || []

    /* preserve kuralları:
     * - edit modu (orderNo var): orijinal davranış — snapshot'lar korunur
     * - create modu: SADECE mevcut satırlar zaten bu tablodan geldiyse korunur
     *   (uid set eşleşmesi). Zara JSON importu satırları aynı tablodan kurup
     *   miktarları yazar; tab değişip bu effect yeniden çalıştığında uid'ler
     *   eşleşir → miktarlar silinmez. Kullanıcı MANUEL farklı tablo seçerse
     *   uid'ler eşleşmez → eski miktarlar taşınmaz (orijinal davranış). */
    const templateUids = new Set(
      findSizeData.sizes.map((s) => s?.uid).filter(Boolean)
    )
    const snapshotUids = new Set(
      snapshots.map((s) => s?.uid).filter(Boolean)
    )
    const sameTable =
      templateUids.size > 0 &&
      snapshotUids.size > 0 &&
      [...templateUids].every((u) => snapshotUids.has(u))
    const preserve = snapshots.length > 0 && (!!orderNo || sameTable)
    const newSizes = findSizeData.sizes.map((item, idx2) => {
      const prev = preserve ? matchSnapshot(item, snapshots, idx2, { isHome: false }) : null
      return {
        name: zaraSizeName(item, findSizeData),
        amount: prev?.amount || '',
        amountWithDefect: prev?.amountWithDefect || '',
        cn: item.cn,
        cm: item.cm,
        uid: item.uid,
        sCode: item.sCode || (item.europe != null ? String(item.europe) : ''),
      }
    })
    setFieldValue(`priceLabel[${idx}].sizes`, newSizes)
  }, [findSizeData, orderNo, values.sizeGroup, idx, setFieldValue]);

  const totalAmount = values.priceLabel[idx].sizes?.reduce((acc, curr) => {
    if (curr.amount) return acc + parseInt(curr.amount)
    return acc
  }, 0)

  const totalAmountWithDefect = values.priceLabel[idx].sizes?.reduce((acc, curr) => {
    const amount = curr.amountWithDefect
    if (amount.length > 1) return acc + parseInt(amount)
    return acc
  }, 0)

  return (
    <div className="rounded border border-dashed p-2">
      <div className="mb-2 grid grid-cols-4 gap-x-5 text-sm font-medium text-simsek">
        <p>Beden</p>
        <p>Adet</p>
        <p>%</p>
        <p>Fireli Adet</p>
      </div>
      <div className="space-y-1">
        {values.priceLabel[idx].sizes.length < 1 ? (
          <div className="bg-rose-400 rounded p-2 text-center my-4">
            <p className="text-white text-sm">Lütfen beden tablosu seçiniz!</p>
          </div>
        ) : (
            <SizeSectionList
              catalogSizes={findSizeData?.sizes}
              rowCount={values.priceLabel[idx].sizes.length}
              renderRow={(index) => {
            const amount = values.priceLabel[idx].sizes[index]?.amount
            const percent =
              (values.priceLabel[idx].sizes[index]?.amount *
                values.priceLabel[idx].sizeDefectivePercent) /
                100 || 0
            const wastageQuantity = String(parseInt(amount) + parseInt(percent))
            return (
              <div className="grid grid-cols-4 gap-x-5" key={index}>
                <Input
                  name={`priceLabel[${idx}].sizes[${index}].name`}
                  disabled
                  autoComplete="off"
                />
                <Input
                  name={`priceLabel[${idx}].sizes[${index}].amount`}
                  onWheel={(e) => e.target.blur()}
                  autoComplete="off"
                />
                <Input
                  name={`priceLabel[${idx}].sizeDefectivePercent`}
                  autoComplete="off"
                  type="number"
                  min={0}
                  max={20}
                  step={1}
                  inputMode="numeric"
                  onWheel={(e) => e.target.blur()}
                  onChange={(e) => {
                    const digitsOnly = String(e.target.value).replace(/\D/g, '')
                    if (digitsOnly === '') {
                      setFieldValue(`priceLabel[${idx}].sizeDefectivePercent`, '')
                      return
                    }
                    let n = parseInt(digitsOnly, 10)
                    if (Number.isNaN(n)) return
                    n = Math.min(20, Math.max(0, n))
                    setFieldValue(`priceLabel[${idx}].sizeDefectivePercent`, n)
                  }}
                />
                <Input
                  name={`priceLabel[${idx}].sizes[${index}].amountWithDefect`}
                  autoComplete="off"
                  value={
                    values.priceLabel[idx].sizes[index].amount.length === 0
                      ? ' '
                      : wastageQuantity
                  }
                  disabled
                />
              </div>
            )
          }}
            />
        )}
        {values.priceLabel[idx].sizes.length > 0 && (
          <div className="grid grid-cols-4 gap-x-10">
            <p></p>
            <p className="text-sm font-semibold text-center">{totalAmount}</p>
            <p></p>
            <p className="text-sm font-semibold text-center">{totalAmountWithDefect}</p>
          </div>
        )}
      </div>
    </div>
  )
}
